import { t, tf } from "./i18n.js";
function toggleMenu() {
  const nav = document.getElementById("main-nav");
  const overlay = document.getElementById("sidebar-overlay");
  if (!nav || !overlay) return;

  const willOpen = !nav.classList.contains("open");
  nav.classList.toggle("open", willOpen);
  overlay.classList.toggle("open", willOpen);

  const btn = document.getElementById("hamburger-btn");
  if (btn) {
    btn.setAttribute("aria-expanded", willOpen ? "true" : "false");
    btn.setAttribute("aria-label", willOpen ? t("js.ui.001") : t("js.ui.002"));
  }
}

// ==========================================
// MODAL-BEDIENUNG PER TASTATUR
//
// Escape schliesst das oberste offene Modal, Tab bleibt darin gefangen.
// Ohne Fokusfalle konnte man aus einem Dialog heraus in die verdeckte
// Seite dahinter navigieren.
// ==========================================
const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function getOpenModals() {
  return [...document.querySelectorAll(".modal-overlay")].filter((m) => {
    const d = m.style.display;
    return d && d !== "none";
  });
}

function closeTopModal() {
  const open = getOpenModals();
  if (open.length === 0) return false;
  const modal = open[open.length - 1];

  // Falls das Modal eine eigene Schliessroutine hat, diese bevorzugen
  const closeBtn = modal.querySelector(".close-btn");
  if (closeBtn) closeBtn.click();
  else modal.style.display = "none";

  // Fokus zurueck auf das Element, das das Modal geoeffnet hat
  if (lastFocusedBeforeModal && document.contains(lastFocusedBeforeModal)) {
    lastFocusedBeforeModal.focus();
    lastFocusedBeforeModal = null;
  }
  return true;
}

let lastFocusedBeforeModal = null;

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    // Erst Modals, dann das Seitenmenue
    if (closeTopModal()) {
      event.preventDefault();
      return;
    }
    const nav = document.getElementById("main-nav");
    if (nav && nav.classList.contains("open")) {
      toggleMenu();
      event.preventDefault();
    }
    return;
  }

  if (event.key !== "Tab") return;

  const open = getOpenModals();
  if (open.length === 0) return;

  const modal = open[open.length - 1];
  const items = [...modal.querySelectorAll(FOCUSABLE)].filter(
    (el) => el.offsetParent !== null,
  );
  if (items.length === 0) return;

  const first = items[0];
  const last = items[items.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    last.focus();
    event.preventDefault();
  } else if (!event.shiftKey && document.activeElement === last) {
    first.focus();
    event.preventDefault();
  } else if (!modal.contains(document.activeElement)) {
    first.focus();
    event.preventDefault();
  }
});

// Beim Oeffnen eines Modals den Fokus hineinsetzen und den Ausloeser merken.
// MutationObserver, weil die Modals ueber style.display gesteuert werden.
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((records) => {
    records.forEach((rec) => {
      const el = rec.target;
      if (!el.classList || !el.classList.contains("modal-overlay")) return;
      const visible = el.style.display && el.style.display !== "none";
      if (!visible || el.dataset.focused === "1") {
        if (!visible) delete el.dataset.focused;
        return;
      }
      el.dataset.focused = "1";
      if (document.activeElement && document.activeElement !== document.body) {
        lastFocusedBeforeModal = document.activeElement;
      }
      const target = el.querySelector(FOCUSABLE);
      if (target) target.focus();
    });
  });

  document.querySelectorAll(".modal-overlay").forEach((m) => {
    observer.observe(m, { attributes: true, attributeFilter: ["style"] });
  });
});

function closeStats(e) {
  if (e.target.id === "stats-modal" || e.target.className === "close-btn")
    document.getElementById("stats-modal").style.display = "none";
}

function switchModalTab(tab) {
  document
    .querySelectorAll(".modal-tab")
    .forEach((b) => b.classList.remove("active"));
  document
    .querySelectorAll(".modal-content-area")
    .forEach((c) => (c.style.display = "none"));

  if (tab === "overview") {
    document.querySelector(".modal-tab:nth-child(1)").classList.add("active");
    document.getElementById("tab-overview").style.display = "block";
  } else {
    document.querySelector(".modal-tab:nth-child(2)").classList.add("active");
    document.getElementById("tab-history").style.display = "block";

    // ---> NEU: Blockiert das Überschreiben bei Bob's und RTW <---
    if (
      typeof currentModalType !== "undefined" &&
      (currentModalType === "501" || currentModalType === "secure")
    ) {
      if (currentModalType === "501" || currentModalType === "secure") {
        if (typeof loadMatchHistory === "function") loadMatchHistory();
      }
    }
  }
}

// Toasts, Bestaetigungs-/Eingabe-Modale und die Darstellungsgroesse sind
// nach ui-kit.js umgezogen (Refactor 07.08.2026, Schritt 2/3): stats.html
// und einstellungen.html brauchen sie ohne den Rest der Spiel-Shell.

// ==========================================
// ZAHLENRASTER FÜR DIE DART-FÜR-DART-EINGABE
// Ersetzt zwei document.write()-Schleifen im HTML. document.write blockiert
// den Parser und ist nach dem Laden der Seite nicht mehr benutzbar.
// ==========================================
function buildCalcNumberGrid(containerId, handler) {
  const container = document.getElementById(containerId);
  if (!container || container.dataset.built) return;

  for (let i = 1; i <= 20; i++) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "calc-num-btn";
    btn.textContent = i;
    btn.addEventListener("click", () => {
      if (typeof window[handler] === "function") window[handler](i);
    });
    container.appendChild(btn);
  }
  container.dataset.built = "1";
}

document.addEventListener("DOMContentLoaded", () => {
  buildCalcNumberGrid("calc-number-grid", "addCalcDart");
  // Party baut sein Zahlengitter seit dem 14.08.2026 selbst
  // (aufnahme-eingabe.js) - hier ist nichts mehr zu erzeugen.
});

// ==========================================
// SETUP-TABS (Lokal / Online)
// ==========================================
// mode: "secure" | "501"   tab: "local" | "online"
function switchSetupTab(mode, tab) {
  ["local", "online"].forEach((name) => {
    const panel = document.getElementById(`${mode}-tab-${name}`);
    if (panel) panel.style.display = name === tab ? "block" : "none";
  });

  // Nur die Tab-Leiste des betroffenen Panels umschalten
  const anyPanel = document.getElementById(`${mode}-tab-local`);
  const bar = anyPanel
    ? anyPanel.parentElement.querySelector(".setup-tabs")
    : null;
  if (bar) {
    bar.querySelectorAll(".setup-tab").forEach((btn) => {
      const active = btn.dataset.tab === tab;
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
  }
}

// ==========================================
// SPIELERNAMEN AUTOMATISCH VORBELEGEN
// ==========================================
// Alle Namensfelder, die mit dem eingeloggten Nutzer belegt werden sollen.
const PLAYER_NAME_FIELDS = [
  "player-input", // Secure lokal
  "local-p1-name", // 501 lokal
  "online-player-name", // 501 online
  "online-player-name-secure", // Secure online
  "bobs-player-input",
  "rtw-player-input",
  "player-121-input",
  "random-player-input",
  "cricket-p1-name",
  "party-player-input",
];

// Modi mit genau einem Spieler: Statt Eingabefeld wird der Name angezeigt.
const SOLO_NAME_FIELDS = [
  { input: "bobs-player-input", display: "bobs-name-display" },
  { input: "rtw-player-input", display: "rtw-name-display" },
  { input: "player-121-input", display: "121-name-display" },
  { input: "random-player-input", display: "random-name-display" },
];

function currentDisplayName() {
  if (typeof isGuest !== "undefined" && isGuest) return "";
  if (typeof myOnlineName === "string" && myOnlineName) return myOnlineName;
  return "";
}

// Fuellt leere Namensfelder mit dem Login-Namen.
function applyPlayerNameDefaults() {
  const name = currentDisplayName();
  if (!name) return;

  PLAYER_NAME_FIELDS.forEach((id) => {
    const el = document.getElementById(id);
    // Nur leere Felder anfassen, damit manuelle Eingaben erhalten bleiben.
    if (el && !el.value) el.value = name;
  });

  applySoloNameDisplay();
}

// Im Solo-Modus braucht es kein Eingabefeld: Name kommt aus dem Login.
// Ohne Login bleibt das Feld sichtbar, damit Gaeste weiterhin spielen koennen.
function applySoloNameDisplay() {
  const name = currentDisplayName();

  SOLO_NAME_FIELDS.forEach(({ input, display }) => {
    const inputEl = document.getElementById(input);
    const displayEl = document.getElementById(display);
    if (!inputEl || !displayEl) return;

    const wrap = inputEl.closest(".name-field-wrap") || inputEl;

    if (name) {
      inputEl.value = name;
      wrap.style.display = "none";
      displayEl.style.display = "flex";
      const nameSpan = displayEl.querySelector(".name-chip-value");
      if (nameSpan) nameSpan.textContent = name;
    } else {
      wrap.style.display = "";
      displayEl.style.display = "none";
    }
  });
}

// ==========================================
// SPIELER-KARUSSELL (Mehrspieler-Layout)
//
//   2 Spieler   -> feste Anordnung links / rechts
//   3+ Spieler  -> Vorheriger | Aktiv | Naechster, rotiert pro Zug
//
// entries: [{ name, score, sub }]  (sub = optionale Zusatzzeile)
// ==========================================
function renderPlayerCarousel(
  containerId,
  entries,
  currentIndex,
  options = {},
) {
  const container = document.getElementById(containerId);
  if (!container || !Array.isArray(entries) || entries.length === 0) return;

  const total = entries.length;
  const accent = options.accent || "var(--accent-blue)";

  container.innerHTML = "";
  container.classList.add("player-carousel");
  container.classList.toggle("carousel-duo", total === 2);
  container.classList.toggle("carousel-solo", total === 1);

  const buildCard = (entry, role) => {
    const card = document.createElement("div");
    card.className = "carousel-card carousel-" + role;
    if (role === "active") card.style.borderColor = accent;

    const roleLabel = document.createElement("div");
    roleLabel.className = "carousel-role";
    roleLabel.textContent =
      role === "active"
        ? options.activeLabel || t("js.ui.014")
        : role === "next"
          ? t("js.ui.003")
          : "ZUVOR";

    const name = document.createElement("div");
    name.className = "carousel-name";
    name.textContent = entry.name;

    const score = document.createElement("div");
    score.className = "carousel-score";
    if (role === "active") score.style.color = accent;
    score.textContent = entry.score;

    card.appendChild(roleLabel);
    card.appendChild(name);
    card.appendChild(score);

    if (entry.sub) {
      const sub = document.createElement("div");
      sub.className = "carousel-sub";
      sub.textContent = entry.sub;
      card.appendChild(sub);
    }
    return card;
  };

  if (total <= 2) {
    // Duell: beide dauerhaft sichtbar, aktiver hervorgehoben
    entries.forEach((entry, i) => {
      container.appendChild(
        buildCard(entry, i === currentIndex ? "active" : "idle"),
      );
    });
    return;
  }

  const prev = (currentIndex - 1 + total) % total;
  const next = (currentIndex + 1) % total;

  container.appendChild(buildCard(entries[prev], "prev"));
  container.appendChild(buildCard(entries[currentIndex], "active"));
  container.appendChild(buildCard(entries[next], "next"));

  // Bei mehr als 3 Spielern zeigt eine Punktreihe die Position im Feld
  if (total > 3) {
    const dots = document.createElement("div");
    dots.className = "carousel-dots";
    entries.forEach((_, i) => {
      const dot = document.createElement("span");
      dot.className = "carousel-dot" + (i === currentIndex ? " active" : "");
      if (i === currentIndex) dot.style.background = accent;
      dots.appendChild(dot);
    });
    container.appendChild(dots);
  }
}

// ==========================================
// UNIVERSAL DARTBOARD RENDERER - ENTFERNT (14.08.2026)
// ==========================================
//
// Hier standen renderUniversalDartboard(), markiereUniversalDartboard() und
// leereUniversalDartboardMarken() - rund 200 Zeilen fuer eine STILISIERTE
// Dartscheibe (Bull 7/16 statt 6,35/15,9 mm, Triple 55-65 statt 99-107 mm).
//
// Ihre einzigen Nutzer waren Bob's 27 und Round the World. Beide zeichnen
// jetzt das echte Board aus dartboard.js, das der gemeinsame Eingabe-
// Baustein mitbringt - dieselbe Geometrie, in der auch der Tracker rechnet.
// Das Zielfeld hebt dort dartboard.js' zeigeZiel() hervor.
//
// Zwei Scheiben mit unterschiedlichen Massen nebeneinander waeren zwei
// Wahrheiten darueber, wo ein Feld liegt: Eine Trackermarke auf der
// stilisierten Scheibe haette systematisch woanders gelegen als der Pfeil.
// Deshalb ersatzlos raus statt liegen gelassen.

// ==========================================
// UNIVERSAL CANCEL GAME (Für ALLE Modi)
// ==========================================
function cancelCurrentGame(screenIdToHide, skipConfirm = false) {
  const executeCancel = () => {
    // 0. Ausdruecklicher Abbruch: Spielwache komplett entwaffnen - auch
    //    der gespiegelte Stand faellt weg (spielwache.js, 29.08.2026).
    if (typeof spielwacheSpielBeendet === "function") {
      spielwacheSpielBeendet();
    }

    // 1. Logik-Stop für 501/Bot aufrufen
    if (typeof stopLocalGameLogic === "function") {
      stopLocalGameLogic();
    }

    // 2. Bildschirm verstecken
    if (screenIdToHide) {
      const el = document.getElementById(screenIdToHide);
      if (el) el.style.display = "none";
    }

    // 3. Variablen für Mini-Games zurücksetzen
    if (typeof rtwPlayer !== "undefined") rtwPlayer = null;
    if (typeof bobsPlayer !== "undefined") bobsPlayer = null;
    // FIX: 121 und die neuen Modi wurden vorher nicht zurueckgesetzt.
    if (typeof player121 !== "undefined") player121 = null;
    if (typeof levelTimer121 !== "undefined" && levelTimer121) {
      clearTimeout(levelTimer121);
      levelTimer121 = null;
    }
    if (typeof isRtwGameOver !== "undefined") isRtwGameOver = false;
    if (typeof resetCricketState === "function") resetCricketState();
    if (typeof resetRandomState === "function") resetRandomState();

    // 4. Overlays aufräumen
    const winOverlay501 = document.getElementById("win-overlay-501");
    if (winOverlay501) winOverlay501.style.display = "none";

    // Punkt 5 (Kamera stoppen) entfiel am 08.08.2026 mit dem Handy-Modus.
    // Der Tracker laeuft eigenstaendig auf dem PC und wird vom Spielabbruch
    // nicht beruehrt; autoscore raeumt seine Aufnahme in goHome() auf.

    goHome();
  };

  if (skipConfirm) {
    executeCancel();
  } else {
    showCancelModal(executeCancel);
  }
}

// ==========================================
// GLOBALE TASTATUR-STEUERUNG (KEYSTROKES)
// ==========================================
document.addEventListener("keydown", function (event) {
  // 1. Ignoriere Tasten, wenn der User gerade in ein Textfeld tippt (z.B. Spielernamen)
  if (
    document.activeElement.tagName === "INPUT" ||
    document.activeElement.tagName === "TEXTAREA"
  ) {
    return;
  }

  // FIX: Autorepeat blockieren. Eine gedrueckt gehaltene Taste hat vorher
  // ganze Spiele in Sekunden durchgehetzt (RTW/Bob's/Secure).
  if (event.repeat) return;

  // 2. Welcher Bildschirm ist gerade aktiv?
  const isCricket =
    document.getElementById("game-cricket-screen")?.style.display === "block";
  const isSecure =
    document.getElementById("game-secure-screen")?.style.display === "block";
  const is501 =
    document.getElementById("game-501-screen")?.style.display === "block";
  const isParty =
    document.getElementById("game-party-screen")?.style.display === "block";

  const key = event.key;

  // RTW und BOB'S 27 hatten hier "0/1/2/3 = so oft getroffen". Mit der
  // Dart-fuer-Dart-Eingabe (14.08.2026) hat eine getippte "2" keine
  // eindeutige Bedeutung mehr - 2, D1 oder zwei Treffer? Dieselbe
  // Begruendung wie beim Wegfall des Party-Ziffernblocks.

  // ---------------------------------------------------------
  // MODUS: CRICKET / TACTICS
  // 1-3 = Multiplikator waehlen, 0 = Fehlwurf, Backspace = Dart zurueck
  // ---------------------------------------------------------
  if (isCricket && typeof handleCricketKey === "function") {
    if (handleCricketKey(key)) event.preventDefault();
  }

  // RANDOM CHECKOUT: "1..N = mit N Darts gecheckt" ist mit der
  // Dart-fuer-Dart-Eingabe entfallen - der Versuch wird geworfen, nicht
  // hinterher gemeldet.

  // CATCH 121, GOTCHA und SCORING hatten hier bzw. am Ziffernblock die
  // Summeneingabe. Auch sie werfen jetzt Dart fuer Dart (Stufe 3,
  // 14.08.2026) - eine getippte "6" waere sonst 6, D3 oder T2.

  // ---------------------------------------------------------
  // MODUS: SECURE-DARTS (Tasten: 0, 1, 2, 3, Enter, Backspace)
  // ---------------------------------------------------------
  if (isSecure) {
    if (["0", "1", "2", "3"].includes(key)) {
      const val = parseInt(key);
      // Phase 1: Punkte werfen (3 Darts)
      if (typeof thrownScore !== "undefined" && thrownScore < 3) {
        addRawScore(val);
      }
      // Phase 2: Sichern auf Bull (nur 0, 1, 2 erlaubt)
      else if (
        typeof thrownSecure !== "undefined" &&
        thrownSecure < 3 &&
        currentRawScore > 0 &&
        val <= 2
      ) {
        addSecure(val);
      }
    } else if (key === "Enter") {
      // Enter = Bestätigen (nächster Zug)
      nextTurn();
    } else if (key === "Backspace") {
      // Backspace = Aktuelle Eingabe zurücksetzen (Reset)
      resetTurnInputs();
    }
  }

  // ---------------------------------------------------------
  // MODUS: 501 & PARTY X01 (Numpad: 0-9, Backspace, Enter)
  // ---------------------------------------------------------
  if (is501 || isParty) {
    const key = event.key;
    const checkoutOverlay = document.getElementById("checkout-overlay");
    if (checkoutOverlay && checkoutOverlay.style.display === "flex") {
      if (["0", "1", "2", "3"].includes(key)) {
        const buttons = document.querySelectorAll("#checkout-buttons .num-btn");

        buttons.forEach((btn) => {
          if (btn.innerText === key) {
            btn.click();
          }
        });

        event.preventDefault();
        return;
      }
    }
    if (/^[0-9]$/.test(key)) {
      // Zahlen tippen. Party hat keinen Ziffernblock mehr (14.08.2026) -
      // dort wird Dart fuer Dart eingegeben, eine getippte Ziffer hat
      // keine eindeutige Bedeutung mehr (20 oder D10 oder T-was?).
      if (is501) append501Input(key);
    } else if (key === "Backspace") {
      // Letzte Ziffer löschen
      if (is501) delete501Input();
    } else if (key === "Enter") {
      // Score bestätigen
      if (is501) submit501Score();
    }
  }
});

// ==========================================
// UNIVERSAL MINI-GAME HISTORY UI (Bob's & RTW)
// ==========================================
function renderUniversalMiniGameHistory(
  containerId,
  nameLabelId,
  playerName,
  pointsTable,
  mode,
) {
  const container = document.getElementById(containerId);
  const nameLabel = document.getElementById(nameLabelId);
  if (!container) return;

  if (nameLabel && playerName) nameLabel.innerText = playerName;

  let html = "";
  if (pointsTable) {
    pointsTable.forEach((entry) => {
      // Unterscheidung der Beschriftung je nach Modus
      let fieldName =
        entry.target === 25
          ? "BULL"
          : mode === "bobs"
            ? `D${entry.target}`
            : entry.target;
      let hitColor =
        entry.hits > 0
          ? "var(--accent-green)"
          : mode === "bobs"
            ? "var(--accent-red)"
            : "#888";

      // Bei Bob's zeigen wir die Punkte an (+40), bei RTW die Treffer (2 Treffer)
      let suffix =
        mode === "bobs"
          ? `${entry.points > 0 ? "+" : ""}${entry.points}`
          : tf("js.ui.010", { p1: entry.hits });

      html += `
          <div style="display:flex; justify-content:space-between; padding:10px 14px; background:var(--glass-bg); border: 1px solid var(--glass-border); margin-bottom:6px; border-radius:8px; font-size: 0.85em; color:var(--text-main);">
            <span style="color:var(--text-muted);">FELD <b style="color:var(--text-main); margin-left:4px;">${fieldName}</b></span>
            <span style="color:${hitColor}; font-weight:800; letter-spacing:0.5px;">${suffix.toUpperCase()}</span>
          </div>`;
    });
  }

  container.innerHTML = html;
  container.scrollTop = container.scrollHeight;
}

// ==========================================
// FREUNDE IM HAUPTMENUE / OFFENE LOBBIES ALS SCREEN
//
// Umbau: Die Freundesliste war ein Modal (friends-modal) und die offenen
// Lobbies ebenfalls (open-lobbies-modal). Die Freundesliste lebt jetzt
// dauerhaft als Panel im Hauptmenue (home-friends-panel), die offenen
// Lobbies sind ein eigenstaendiger Screen (open-lobbies-screen) in
// ALL_SCREENS. Die alten Modal-Funktionen sind ersatzlos entfallen.
// ==========================================

// Der fruehere Nav-Knopf "Freunde" ist entfallen: Die Freundesliste lebt
// als aufklappbare Leiste direkt im Hauptmenue (toggleFriendsPanel in
// friends.js) und braucht keinen eigenen Sidebar-Eintrag mehr.

function openOpenLobbiesScreen() {
  if (isGuest || !currentUser) {
    showToast(t("js.ui.004"), "error");
    return;
  }
  hideAllScreens();
  showScreenElement(document.getElementById("open-lobbies-screen"));
  loadOpenLobbies();
}

async function loadOpenLobbies() {
  const container = document.getElementById("open-lobbies-list");
  container.innerHTML =
    `<div style="text-align: center; color: var(--text-muted); padding: 20px;">${t("js.ui.011")}</div>`;

  // Lade alle Lobbies im Status 'waiting', bei denen noch kein Spieler 2
  // existiert. Aeltere als 4 Stunden sind mit hoher Sicherheit verwaist
  // (Host-Tab zu, Cleanup greift nur beim naechsten Login des Hosts).
  const fourHoursAgo = new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString();
  const { data, error } = await _supabase
    .from("live_matches")
    .select(
      "room_code, player1_name, best_of_legs, starting_score, camera_required, host_avg, created_at",
    )
    .eq("status", "waiting")
    .is("player2_name", null)
    .eq("is_public", true)
    .gte("created_at", fourHoursAgo)
    .order("created_at", { ascending: false });

  if (error) {
    container.innerHTML =
      `<div style="text-align: center; color: var(--accent-red); padding: 20px;">${t("js.ui.012")}</div>`;
    return;
  }

  if (!data || data.length === 0) {
    // Einheitliches Empty-State-Muster (GUI-Plan P2.5, ui-kit.js)
    if (typeof renderEmptyState === "function") {
      renderEmptyState(container, {
        text: t("js.ui.005"),
        actionLabel: t("js.ui.015"),
        onAction: () => {
          if (typeof enterMode === "function") enterMode("501");
          if (typeof switchSetupTab === "function")
            switchSetupTab("501", "online");
        },
      });
    } else {
      container.innerHTML =
        `<div style="text-align: center; color: var(--text-muted); padding: 20px;">${t("js.ui.013")}</div>`;
    }
    return;
  }

  let html = "";
  data.forEach((lobby) => {
    // 1. Kamera-Badge formatieren
    let camBadge = lobby.camera_required
      ? `<span style="background: var(--accent-red); color: white; padding: 2px 6px; border-radius: 4px; font-size: 0.75em; margin-left: 8px; font-weight: bold;">Kamera Req.</span>`
      : "";

    // 2. Average robust formatieren (Fängt null, undefined und 0 sauber ab)
    let avgDisplay =
      lobby.host_avg !== null && lobby.host_avg !== undefined
        ? `<span style="color: var(--accent-blue); font-size: 0.85em; margin-left: 8px; font-weight: bold;">(Avg: ${Number(
            lobby.host_avg,
          ).toFixed(2)})</span>`
        : `<span style="color: var(--text-muted); font-size: 0.85em; margin-left: 8px;">(Avg: -)</span>`;

    // 3. Eigene Lobby Check (damit man sich nicht selbst joint)
    let isMyLobby = lobby.player1_name === myOnlineName;

    let actionButton = isMyLobby
      ? `<button class="reset" style="margin: 0; padding: 10px 20px; width: auto; font-size: 0.9em; opacity: 0.6; cursor: not-allowed;" disabled>Eigene Lobby</button>`
      : `<button class="primary accent-green" style="margin: 0; padding: 10px 20px; width: auto; font-size: 0.9em;" onclick="joinSpecificLobby('${lobby.room_code}')">Join</button>`;

    html += `
      <div class="glass-panel" style="padding: 15px; margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center; border-color: var(--glass-border);">
        <div style="text-align: left;">
          <div style="font-weight: bold; font-size: 1.1em; display: flex; align-items: center;">
            <a href="#" onclick="event.preventDefault(); openPlayerStatsFromName('${
              lobby.player1_name
            }')" style="color: white; text-decoration: none; transition: color 0.2s;" onmouseover="this.style.color='var(--accent-blue)'" onmouseout="this.style.color='white'">
              ${lobby.player1_name}
            </a> 
            ${avgDisplay}
          </div>
          <div style="font-size: 0.85em; color: var(--text-muted); margin-top: 5px; display: flex; align-items: center;">
            ${lobby.starting_score || 501} - Bo${
              lobby.best_of_legs
            } ${camBadge} </div>
        </div>
        ${actionButton}
      </div>
    `;
  });

  container.innerHTML = html;
}

async function openPlayerStatsFromName(playerName) {
  // 1. Versuche zuerst die 501 Stats zu laden (da wir uns im 501 Modus befinden)
  let { data: stats501 } = await _supabase
    .from("stats_501")
    .select("*")
    .eq("name", playerName)
    .maybeSingle();

  if (stats501) {
    // Öffnet das 501-Stats-Modal mit den geladenen Daten
    open501Stats(encodeURIComponent(JSON.stringify(stats501)));
  } else {
    // 2. Fallback: Falls der Spieler noch nie 501 gespielt hat, probiere Secure Darts
    let { data: statsSecure } = await _supabase
      .from("stats_secure")
      .select("*")
      .eq("name", playerName)
      .maybeSingle();

    if (statsSecure) {
      openProStats(encodeURIComponent(JSON.stringify(statsSecure)));
    } else {
      // 3. Wenn gar keine Daten existieren
      showToast(t("js.ui.006"), "info");
    }
  }
}

function joinSpecificLobby(roomCode) {
  let nameInput = document.getElementById("online-player-name");

  // Sicherstellen, dass der Nutzer seinen Namen eingetragen hat.
  // Der Lobby-Screen wird dabei ueber hideAllScreens() verlassen.
  if (!nameInput.value.trim()) {
    showToast(t("js.ui.007"), "error");
    hideAllScreens();
    showScreenElement(document.getElementById("online-lobby-screen"));
    nameInput.focus();
    return;
  }

  // Raumcode in das Feld setzen und die existierende Join-Funktion auslösen
  let codeInput = document.getElementById("join-room-code");
  if (codeInput) {
    codeInput.value = roomCode;
  }
  joinOnlineGame();
}

// Die Einstellungen (openSettingsModal/saveSettings/generatePairingCode)
// sind nach settings.js bzw. einstellungen.html umgezogen (Refactor
// 07.08.2026, Schritt 3).

// Avatar-Auswahl: erst lokale Sofortvorschau, dann der echte Upload.
//
// FIX: handleAvatarUpload() aus camera.js wurde nie aufgerufen - es gab nur
// diesen Listener, der ausschliesslich die Vorschau gesetzt hat. Ein neues
// Profilbild landete deshalb nie auf dem Server.
document.addEventListener("DOMContentLoaded", () => {
  const avatarInput = document.getElementById("avatar-upload");
  if (!avatarInput) return;

  avatarInput.addEventListener("change", function (event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = function (e) {
      ["settings-avatar-preview", "modal-avatar-preview"].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.src = e.target.result;
      });
    };
    reader.readAsDataURL(file);

    if (typeof handleAvatarUpload === "function") handleAvatarUpload(event);
  });
});

// Diese Funktion MUSS im Code existieren, sonst passiert beim Klick nichts!
function openPairingInputModal(callback) {
  const modal = document.getElementById("pairing-input-modal");
  const input = document.getElementById("pairing-code-input");
  const submitBtn = document.getElementById("btn-submit-pairing");

  if (!modal || !input || !submitBtn) {
    console.error(t("js.ui.008"));
    return;
  }

  // Feld leeren und Modal anzeigen
  input.value = "";
  modal.style.display = "flex";
  input.focus();

  // Klick-Event für den "Verifizieren"-Button
  submitBtn.onclick = async () => {
    const code = input.value.trim();
    if (!code || code.length !== 6) {
      showToast(t("js.ui.009"), "warning");
      return;
    }

    // Modal schließen und den eingegebenen Code an die Hauptfunktion zurückgeben
    modal.style.display = "none";
    if (callback) callback(code);
  };
}

//

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  toggleMenu,
  closeStats,
  switchModalTab,
  buildCalcNumberGrid,
  switchSetupTab,
  applyPlayerNameDefaults,
  renderPlayerCarousel,
  cancelCurrentGame,
  renderUniversalMiniGameHistory,
  openOpenLobbiesScreen,
  loadOpenLobbies,
  // Beide werden aus dem erzeugten Markup der Lobbyliste per inline
  // onclick gerufen (ui.js:829 "Join", ui.js:835 Hostname). Ohne Eintrag
  // hier gibt es beim Klick nur ein "is not defined" in der Konsole und
  // sichtbar gar nichts - so gemeldet im Alphatest am 09.08.2026.
  joinSpecificLobby,
  openPlayerStatsFromName,
  openPairingInputModal,
});
